import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import PlayerSorter from './PlayerSorter'
import loginUser from '../services/login'
import { useDispatch } from 'react-redux'
import { fetchListPlayers } from '../reducers/listReducer'

const PlayerList = () => {
  const { id } = useParams()
  const [players, setPlayers] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const loadData = async () => {
      try {
        await loginUser(dispatch)
        const loggedUser = window.localStorage.getItem('loggedUser')
        const token = loggedUser ? JSON.parse(loggedUser) : null

        if (!token) {
          console.error('No token available')
          return
        }

        // Hae listan pelaajat Reduxista (tai backendistä jos ei cachessa)
        const result = await dispatch(fetchListPlayers(id, token))
        setPlayers(result)
      } catch (error) {
        console.error('Error fetching players:', error)
      }
    }
    loadData()
  }, [id])

  return (
    <>
      {players.length > 0 ? (
        <PlayerSorter players={players} />
      ) : (
        <Table striped bordered hover variant="dark" size="sm">
          <tbody>
            <tr>
              <td>
                <Spinner animation="border" />
              </td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  )
}

export default PlayerList
